"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../helpers/index.js");
var _index2 = require("../../../utils/index.js");
var _utils = require("./utils");
var _excluded = ["isToolSaved", "isToolStep", "toolName", "toolUsageID", "hasMultipleSteps", "toolUsageStepName", "toolType", "toolSelections", "eventResponses", "outageID", "outageStatus", "isSsa", "ssaName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var stringField = _index.formatters.stringField,
  listField = _index.formatters.listField;
var stepNumberKeys = _utils.stepNumberKey.stepNumberKeys,
  getStepNumberKey = _utils.stepNumberKey.getStepNumberKey;

// Keys that cannot be customized since they have a default value or works with a custom behavior
var lockedFields = ['toolUsageStart', 'toolUsageSaved', 'toolUsageStep'].concat(_toConsumableArray(stepNumberKeys));
var getToolStartTemplate = function getToolStartTemplate(_ref) {
  var isToolSaved = _ref.isToolSaved,
    isToolStep = _ref.isToolStep,
    toolName = _ref.toolName,
    toolUsageID = _ref.toolUsageID,
    _ref$hasMultipleSteps = _ref.hasMultipleSteps,
    hasMultipleSteps = _ref$hasMultipleSteps === void 0 ? false : _ref$hasMultipleSteps,
    toolUsageStepName = _ref.toolUsageStepName,
    toolType = _ref.toolType,
    toolSelections = _ref.toolSelections,
    eventResponses = _ref.eventResponses,
    outageID = _ref.outageID,
    outageStatus = _ref.outageStatus,
    _ref$isSsa = _ref.isSsa,
    isSsa = _ref$isSsa === void 0 ? false : _ref$isSsa,
    ssaName = _ref.ssaName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cleanedRest = (0, _index2.removeLockedKeys)(rest, lockedFields);
  var stepNumberField = hasMultipleSteps ? getStepNumberKey(1) : {};
  var ssaFields = isSsa ? {
    ssaStart: 1,
    ssaName: stringField(ssaName)
  } : {};
  return {
    _telus: _objectSpread(_objectSpread(_objectSpread({
      toolUsageStart: 1,
      toolUsageSaved: isToolSaved ? 1 : undefined,
      toolUsageStep: isToolStep ? 1 : undefined,
      toolName: stringField(toolName),
      toolUsageID: toolUsageID,
      toolUsageStepName: stringField(toolUsageStepName),
      toolType: stringField(toolType),
      toolSelections: listField(toolSelections),
      eventResponses: listField(eventResponses),
      outageID: outageID,
      outageStatus: outageStatus
    }, stepNumberField), ssaFields), cleanedRest)
  };
};
var _default = exports["default"] = getToolStartTemplate;